<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/193KhZF/tc-custom/9780292760738.jpg?1704918553296" alt="This image is the cover for the book Aransas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Aransas
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Beneath the genial surface” of this “resonant” first novel about a dolphin trainer who struggles with the ethics of his job “allusive undercurrents tug” (<i>The </i><i>New York Times Book Review</i>).</b><br/>  <br/> A critically acclaimed debut novel first published in 1980, <i>Aransas</i> recounts a young man’s homecoming to his small Gulf Coast fishing town of Port Aransas. As Jeff Downing begins work training two porpoises to become part of a tourist attraction, he comes to love them as well as the woman who wants to release the pair to the wild.<br/>  <br/> “The sureness and poise of this first novel are as remarkable as the sharpness, oddity, and clarity of its feelings.” ―<i>Newsweek</i><br/>  <br/> “Harrigan’s eye for locale and its effect is superb.” —<i>Washington Post Book World</i><br/>  <br/> “Harrigan . . . Has a sharp eye for observing man, beast, seashore, and town in a vividly drawn setting.” ―<i>Publishers Weekly</i><br/>  <br/> “An ardent and elegant book, beautiful in its language, mature in its perceptions, noble in its sentiments.” ―<i>San Francisco Chronicle</i><br/>  <br/> “Sensitive [and] enormously evocative first . . . Spare but warm prose . . . Immerses us in atmosphere as insistently as it does the plot . . . Harrigan is a splendid novelist.” —<i>Houston Post</i><br/>  <br/> “<i>Aransas</i> has several surprises, including dramatic suspense, counterculture revisionism, and what must be considered dolphin revisionism. More, Harrigan has written an acute American regional novel.” —<i>The </i><i>Village Voice</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Harrigan
      </h2>
      
      <p class="authorDescription body article"> STEPHEN HARRIGAN is the author of nine books of fiction and nonfiction, including the award-winning novels The Gates of the Alamo and Remember Ben Clayton and the critically acclaimed essay collection The Eye of the Mammoth. He lives in Austin, Texas, where he is a writer-at-large for Texas Monthly and a faculty fellow at the University of Texas&rsquo;s Michener Center for Writers. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b70436b